export default __webpack_public_path__ + "static/screeny-55-gp-xs-2-6af705f79becff6e36d039b9c7bb1bdc.jpg";